const practiceImagePath = "/react-current/images/practice";

const photos = [{
  src: `${practiceImagePath}/nuclear-cardiac-imaging.jpg`,
  caption: "Advanced Nuclear Cardiac Imaging"
}, {
  src: `${practiceImagePath}/cardiac-catheterization-lab.jpg`,
  caption: "Cardiac Catheterization Lab"
}, {
  src: `${practiceImagePath}/ekg-cardiac-monitoring.jpg`,
  caption: "On-Site EKG and Cardiac Monitoring"
}, {
  src: `${practiceImagePath}/pacemaker-device-clinic.jpg`,
  caption: "Pacemaker and Device Monitoring"
}, {
  src: `${practiceImagePath}/boynton-office.jpg`,
  caption: "Our Boynton Beach Office"
}];
export default function Gallery() {
  return <section className="bg-[var(--color-dark-navy)] pt-12 pb-24 px-6 lg:px-12 font-default">
      <h2 className="font-default font-bold text-2xl md:text-3xl uppercase tracking-tight text-white mb-8">A Closer Look At Our Practice</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-5 max-w-3xl mx-auto">
        {photos.map((photo, i) => <div key={i}>
            <div className="w-full aspect-[4/3] overflow-hidden rounded-md bg-black/20">
              <img src={photo.src} alt={photo.caption} loading="lazy" decoding="async" className="w-full h-full object-cover object-center" />
            </div>
            <p className="mt-3 text-sm text-soft-gray">{photo.caption}</p>
          </div>)}
      </div>
    </section>;
}
